import React from "react";
import "./PaginationComp.css";
import { BaselineKeyboardArrowLeft } from "../../../../svgs/BaselineKeyboardArrowLeft";
import { BaselineKeyboardArrowRight } from "../../../../svgs/BaselineKeyboardArrowRight";

const PaginationComp = ({
  currentPage,
  itemsPerPage,
  totalItems,
  onPageChange,
  onRowsPerPageChange,
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const maxVisiblePages = 9;

  let start = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  let end = Math.min(totalPages, start + maxVisiblePages - 1);
  if (end - start < maxVisiblePages - 1) {
    start = Math.max(1, end - maxVisiblePages + 1);
  }

  const pageNumbers = [];
  for (let i = start; i <= end; i++) pageNumbers.push(i);

  return (
    <div className="pagination-container">
      {/* Rows per page on left */}
      {/* <div className="pagination-left">
        <select
          className="pagination-select"
          value={itemsPerPage}
          onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
        >
          {[5, 10, 20, 50].map((n) => (
            <option key={n} value={n}>
              Show {n}
            </option>
          ))}
        </select>
      </div> */}

      {/* Page navigation in center */}
      {/* <div className="pagination-wrapper"> */}
        <div className="pagination-comp-inner">
          <button
            className="pagination-btn"
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <BaselineKeyboardArrowLeft />
          </button>

          {pageNumbers.map((num) => (
            <button
              key={num}
              className={`pagination-page ${
                currentPage === num ? "active" : ""
              }`}
              onClick={() => onPageChange(num)}
            >
              {num}
            </button>
          ))}

          <button
            className="pagination-btn"
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            <BaselineKeyboardArrowRight />
          </button>
        </div>
      </div>
    // </div>
  );
};

export default PaginationComp;
